export default "__VITE_ASSET__BEp1Oa0a__"